import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const crmOpportunitiesWidget: DashboardWidgetConfiguration = {
  widgetId: "crm.opportunities",
  name: "Open opportunities",
  description: "Open opportunities for the selected dashboard period.",
  apps: [
    "home",
    "crm",
  ],
  template: "number",
  query: {
    kind: "single",
    query: {
      version: 1,
      source: "crm.prospects",
      ...period(30),
      select: [
        {
          type: "aggregate",
          function: "count_distinct",
          field: "prospect_id",
          as: "value",
        },
      ],
      where: {
        type: "condition",
        field: "prospect_type",
        operator: "eq",
        value: "opportunity",
      },
    },
  },
  inputs: {
    label: "Opportunities",
    subtext: "in the last 30 days",
    icon: "trend",
    color: "success",
    valueFormat: "number",
    valueMultiplier: 1,
  },
  dummyData: {
    value: 21,
    subtext: "Last 30 days",
  },
  limits: {
    minWidth: 2,
    maxWidth: 6,
    minHeight: 1,
    maxHeight: 2,
    defaultWidth: 4,
    defaultHeight: 1,
  },
};
